"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var GameSetsList_1 = require("./component/GameSetsList");
//import GameSetGamesList  from "./component/GameSetGamesList";
var GameSetsEditor_1 = require("./component/GameSetsEditor");
var GameSetLocalesList_1 = require("./component/locales/GameSetLocalesList");
var GameSetLocaleEditor_1 = require("./component/locales/GameSetLocaleEditor");
var GameSetOperations_1 = require("./component/GameSetOperations");
var GameSetBetTargetEditor_1 = require("./component/fsbettargets/GameSetBetTargetEditor");
var GameSetBetTargetsList_1 = require("./component/fsbettargets/GameSetBetTargetsList");
var PGameProviderGameSetsList = /** @class */ (function (_super) {
    __extends(PGameProviderGameSetsList, _super);
    function PGameProviderGameSetsList(props) {
        return _super.call(this, props) || this;
    }
    PGameProviderGameSetsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_CGT = this.props.gameSetTypesData.Subscribe("*", function (id, data) {
            _this.setState({ avail_cms_gameset_type: data.data });
        });
        this.SID_AC = this.props.listAppCurrency.Subscribe("*", function (id, data) {
            _this.setState({ avail_currency: data.data });
        });
        this.SID_AG = this.props.gameProvidersData.Subscribe("*", function (id, data) {
            _this.setState({ avail_gameproviders: data.data });
        });
        this.SID_AL = this.props.listAvailAppLanguages.Subscribe("*", function (id, data) {
            _this.setState({ avail_languages: data.data });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                page_size: data.tablePageSize,
                all_currency: data.all_currency,
                currency_id: data.currency_id
            });
        });
        this.setState({
            edit_mode: "LIST",
            rootRecord: null,
            page_num: 1,
            page_size: this.props.state.getTablePageSize(),
            all_gws_gameproviders: true,
            avail_gameproviders: [],
            gws_gameproviders_list: [],
            titleRecord: null,
            currency_id: this.props.state.getCurrencyId(),
            all_currency: this.props.state.getIsAllCurrency(),
            avail_currency: [],
            fsBetRecord: null
        }, function () {
            _this.props.gameProvidersData.LoadData();
            _this.props.listAvailAppLanguages.LoadData();
            _this.props.listAppCurrency.LoadData();
            _this.props.gameSetTypesData.LoadData();
        });
    };
    PGameProviderGameSetsList.prototype.componentWillUnmount = function () {
        this.props.gameProvidersData.UnSubscribe(this.SID_AG);
        this.props.listAvailAppLanguages.UnSubscribe(this.SID_AL);
        this.props.state.UnSubscribe(this.SID_STATE);
        this.props.listAppCurrency.UnSubscribe(this.SID_AC);
        this.props.gameSetTypesData.UnSubscribe(this.SID_CGT);
    };
    PGameProviderGameSetsList.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", rootRecord: null });
    };
    PGameProviderGameSetsList.prototype.onEditClick = function (val) {
        this.setState({ edit_mode: "EDIT", rootRecord: val });
    };
    PGameProviderGameSetsList.prototype.onEditConfigClick = function (val) {
        this.setState({ edit_mode: "DETAIL", rootRecord: val });
    };
    PGameProviderGameSetsList.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", rootRecord: null });
    };
    PGameProviderGameSetsList.prototype.onGoBackTranslateClick = function () {
        this.setState({ edit_mode: "LOCALE-LIST" });
    };
    PGameProviderGameSetsList.prototype.onTranslateListClick = function (val) {
        this.setState({ edit_mode: "LOCALE-LIST", rootRecord: val });
    };
    PGameProviderGameSetsList.prototype.onNewTranslateClick = function () {
        this.setState({ edit_mode: "LOCALE-NEW", titleRecord: null });
    };
    PGameProviderGameSetsList.prototype.onEditTranslateClick = function (val) {
        this.setState({ edit_mode: "LOCALE-EDIT", titleRecord: val });
    };
    PGameProviderGameSetsList.prototype.onGoBackFSBetClick = function () {
        this.setState({ edit_mode: "FSBET-LIST" });
    };
    PGameProviderGameSetsList.prototype.onFSBetListClick = function (val) {
        this.setState({ edit_mode: "FSBET-LIST", rootRecord: val });
    };
    PGameProviderGameSetsList.prototype.onNewFSBetClick = function () {
        this.setState({ edit_mode: "FSBET-NEW", fsBetRecord: null });
    };
    PGameProviderGameSetsList.prototype.onEditFSBetClick = function (val) {
        this.setState({ edit_mode: "FSBET-EDIT", fsBetRecord: val });
    };
    PGameProviderGameSetsList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PGameProviderGameSetsList.prototype.onCurrencyFilterChanged = function (allCurrency, CurrencyId) {
        this.props.state.setAllCurrency(allCurrency, true);
        this.props.state.setCurrencyId(CurrencyId, true);
    };
    PGameProviderGameSetsList.prototype.onGwsGameProviderFilterChanged = function (allGwsGameProviders, GwsGameProviderId, Action) {
        if (Action === "checkbox") {
            this.setState({ all_gws_gameproviders: allGwsGameProviders });
        }
        if (Action === "add") {
            var new_list = this.state.gws_gameproviders_list.slice();
            new_list.push(GwsGameProviderId);
            this.setState({ gws_gameproviders_list: new_list });
        }
        if (Action === "remove") {
            var new_list = this.state.gws_gameproviders_list.slice();
            var index = new_list.indexOf(GwsGameProviderId);
            if (index !== -1) {
                new_list.splice(index, 1);
            }
            this.setState({ gws_gameproviders_list: new_list });
        }
    };
    PGameProviderGameSetsList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(GameSetsEditor_1.default, { data: this.props.gameSetData, state: this.props.state, record: null, onGoBack: this.onGoBackClick.bind(this), availGameproviders: this.state.avail_gameproviders, listCssClasses: this.props.listCssClasses, dlgSelectCss: this.props.dlgSelectCss, dataCmsGameSetCategoryType: this.state.avail_cms_gameset_type, listGwsCategoryAvail: this.props.listGwsCategoryAvail }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(GameSetsEditor_1.default, { data: this.props.gameSetData, state: this.props.state, record: this.state.rootRecord, onGoBack: this.onGoBackClick.bind(this), availGameproviders: this.state.avail_gameproviders, listCssClasses: this.props.listCssClasses, dlgSelectCss: this.props.dlgSelectCss, dataCmsGameSetCategoryType: this.state.avail_cms_gameset_type, listGwsCategoryAvail: this.props.listGwsCategoryAvail }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(GameSetsList_1.default, { data: this.props.gameSetData, state: this.props.state, onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this), onTranslateClick: this.onTranslateListClick.bind(this), onConfigClick: this.onEditConfigClick.bind(this), onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, gwsGameProvidersList: this.state.gws_gameproviders_list, allGwsGameProviders: this.state.all_gws_gameproviders, availGwsGameProviders: this.state.avail_gameproviders, onGwsGameProviderFilterChanged: this.onGwsGameProviderFilterChanged.bind(this), gameSetTypesData: this.props.gameSetTypesData, gameSetFreeSpinBetTargetsData: this.props.gameSetFreeSpinBetTargetsData, onFSBetClick: this.onFSBetListClick.bind(this), dlgAddGame: this.props.dlgAddGame }));
        }
        if (this.state.edit_mode === "DETAIL") {
            return (React.createElement(GameSetOperations_1.default, { data: this.props.gameSetGamesData, state: this.props.state, record: this.state.rootRecord, onGoBackClick: this.onGoBackClick.bind(this), dlgNumericEditor: this.props.dlgNumericEditor, currencyId: this.state.currency_id, allCurrency: this.state.all_currency, availCurrency: this.state.avail_currency, onCurrencyFilterChanged: this.onCurrencyFilterChanged.bind(this), dlgGameEdit: this.props.dlgGameEdit, botWinsData: this.props.botWinsData, listBotWinTypes: this.props.listBotWinTypes }));
        }
        if (this.state.edit_mode === "LOCALE-LIST") {
            return (React.createElement(GameSetLocalesList_1.default, { data: this.props.gameSetLocalesData, state: this.props.state, onGoBack: this.onGoBackClick.bind(this), rootRecord: this.state.rootRecord, onNewClick: this.onNewTranslateClick.bind(this), onEditClick: this.onEditTranslateClick.bind(this) }));
        }
        if (this.state.edit_mode === "LOCALE-NEW") {
            return (React.createElement(GameSetLocaleEditor_1.default, { data: this.props.gameSetLocalesData, state: this.props.state, onGoBack: this.onGoBackTranslateClick.bind(this), rootRecord: this.state.rootRecord, record: this.state.titleRecord, availLanguages: this.state.avail_languages }));
        }
        if (this.state.edit_mode === "LOCALE-EDIT") {
            return (React.createElement(GameSetLocaleEditor_1.default, { data: this.props.gameSetLocalesData, state: this.props.state, onGoBack: this.onGoBackTranslateClick.bind(this), rootRecord: this.state.rootRecord, record: this.state.titleRecord, availLanguages: this.state.avail_languages }));
        }
        if (this.state.edit_mode === "FSBET-LIST") {
            return (React.createElement(GameSetBetTargetsList_1.default, { data: this.props.gameSetFreeSpinBetTargetsData, state: this.props.state, onGoBack: this.onGoBackClick.bind(this), rootRecord: this.state.rootRecord, onNewClick: this.onNewFSBetClick.bind(this), onEditClick: this.onEditFSBetClick.bind(this) }));
        }
        if (this.state.edit_mode === "FSBET-NEW") {
            return (React.createElement(GameSetBetTargetEditor_1.default, { data: this.props.gameSetFreeSpinBetTargetsData, state: this.props.state, onGoBack: this.onGoBackFSBetClick.bind(this), rootRecord: this.state.rootRecord, record: this.state.fsBetRecord, availCurrency: this.state.avail_currency }));
        }
        if (this.state.edit_mode === "FSBET-EDIT") {
            return (React.createElement(GameSetBetTargetEditor_1.default, { data: this.props.gameSetFreeSpinBetTargetsData, state: this.props.state, onGoBack: this.onGoBackFSBetClick.bind(this), rootRecord: this.state.rootRecord, record: this.state.fsBetRecord, availCurrency: this.state.avail_currency }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PGameProviderGameSetsList.prototype.render = function () {
        return this.getRenderObject();
    };
    PGameProviderGameSetsList.getPageDescription = function (state) {
        return {
            icon: "object-group",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_cms_games_list + "-id",
            itemTitle: "Наборы игр",
            route: routes_1.routes.page_cms_games_list,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PGameProviderGameSetsList;
}(React.Component));
exports.default = PGameProviderGameSetsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_gamesets_list/ui/PGameProviderGameSetsList.tsx
// module id = 1993
// module chunks = 0